import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Div } from 'client/widget-components/basicComponents';
import Checkbox from 'client/widget-components/basicComponents/Checkbox/Checkbox';
import {
    CheckboxChoice,
    CheckboxLimitations,
} from 'client/widget-components/ecom/stores/types';
import { mergeResponsiveStyles } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React from 'react';
import { CUSTOMIZATIONS_DATA_GRABS } from '../../constants';
import { ProductCustomizationsStyles } from '../../types';

interface CheckboxCustomizationChoicesProps {
    choices?: CheckboxChoice[];
    limitations?: CheckboxLimitations;
    value: string[];
    onChange: (label: string, checked: boolean) => void;
    styles?: ProductCustomizationsStyles;
}

const CheckboxCustomizationChoices = ({
    choices,
    value,
    styles,
    onChange,
}: CheckboxCustomizationChoicesProps) => (
    <Div
        styles={mergeResponsiveStyles([
            defaultContainerStyles,
            styles?.choicesContainer,
        ])}
        data-grab={CUSTOMIZATIONS_DATA_GRABS.choicesContainerDataGrab}
    >
        {choices?.map((choice) => (
            <Checkbox
                key={choice.label}
                checked={value.includes(choice.label)}
                onChange={(e) => onChange(choice.label, e.target.checked)}
                dataGrab={CUSTOMIZATIONS_DATA_GRABS.choiceDataGrab}
                labelDataGrab={CUSTOMIZATIONS_DATA_GRABS.choiceLabelDataGrab}
                checkedDataGrab={CUSTOMIZATIONS_DATA_GRABS.choiceCheckedDataGrab}
                dataAuto={`customization-choice-${choice.label}`}
                styles={{
                    checkboxRow: checkboxRowDefaultStyles,
                    checkbox: styles?.choice,
                    checkboxChecked: styles?.choiceChecked,
                    checkboxLabel: styles?.choiceLabel,
                }}
            >
                {choice.label}
            </Checkbox>
        ))}
    </Div>
);

export default CheckboxCustomizationChoices;

const defaultContainerStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: 'repeat(auto-fill, minmax(24px, 1fr))',
        gap: '8px',
    },
    [RuntimeMediaQuery.MOBILE]: {
        gridTemplateColumns: 'repeat(1, 1fr)',
    },
};

const checkboxRowDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
    },
};
